import React from "react";

export default function Next({ baseSlug = "all-pages", current = 1, total = 1, assets = "" }) {
    // Using inline SVG instead of image
    const nextIcon = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-right"
        >
            <polyline points="9,18 15,12 9,6"></polyline>
        </svg>
    );

    return (
        <>
            {current < total ? (
                <a
                    href={`#/${baseSlug}/page/${parseInt(current) + 1}`}
                    className="flex text-ec-title font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-md hover:border-ec-primary hover:text-ec-primary transition-colors duration-200 active:text-ec-primary focus:text-ec-primary"
                >
                    <span>Next</span>
                    <div className="text-ec-primary">
                        {nextIcon}
                    </div>
                </a>
            ) : (
                <div className="flex text-ec-disabled font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-md cursor-not-allowed opacity-50">
                    <span>Next</span>
                    <div>
                        {nextIcon}
                    </div>
                </div>
            )}
        </>
    );
}